import React, { FC, useRef, useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { useAccCenterApplyRecent, useDeleteAccCenterApplyRecent } from '@repository/acc';
import ContinueApplyModal from '@components/acca/test/accaTestList/continueApply';
import { AccApplyItemVO } from '@domain/vo/acca/test/AccApplyRecentVO';
import Colors from '@domain/constant/colors';
import useClickAway from '@utils/hooks/useClickOutside';
import { V2Route } from '@utils/routeUtil';

import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './resultListItem.module.scss';
const cx = classnames.bind(styles);

interface ResultListItemProps {
  data: AccApplyItemVO;
  userName: string;
  applyUrl: string;
}
type ModalState = 'MENU' | 'CONTINUE' | null;

const ResultListItem: FC<ResultListItemProps> = ({ data, userName, applyUrl }) => {
  const resultListItem = useRef<HTMLDivElement>(null);
  const [modalState, setModalState] = useState<ModalState>(null);
  const isVisible = (state: ModalState) => state === modalState;
  const { mutateAsync: deleteApplyRecent } = useDeleteAccCenterApplyRecent();
  const { refetch } = useAccCenterApplyRecent(true);

  const title = data.title ?? '잡다';

  const clickMenuBtn = () => {
    if (modalState === 'MENU') setModalState(null);
    else setModalState('MENU');
  };

  const clickContinueBtn = () => {
    if (modalState === 'CONTINUE') setModalState(null);
    else setModalState('CONTINUE');
  };

  const onClickRemoveButton = async () => {
    setModalState(null);
    await deleteApplyRecent(data.sn);
    refetch();
  };

  //이어하기 버튼 클릭시
  const handleApplyTest = () => {
    if (!data.code) return null;

    UrlUtil.openWindowWithPost(applyUrl, {
      authenticationCode: data.code,
      name: userName,
    });

    clickContinueBtn();
  };

  useClickAway(() => setModalState(null), resultListItem);

  return (
    <>
      <div className={cx('listItem')} ref={resultListItem}>
        {/* [D] 썸네일 */}
        <div className={cx('itemThumbnail')}>
          {/* 썸네일 이미지 */}
          {/* [D] 영상촬영을 했지만 응시추가가 필요한 경우: 썸네일 노출 + 추가 응시필요 조건 추가 */}
          {data.thumbnailUrl ? (
            <img className={cx('thumbnailScreen')} src={data.thumbnailUrl} alt="역검 결과표" width={280} height={160} />
          ) : (
            <div className={cx('noThumbnail')} />
          )}
          {/* 추가 응시 필요 뱃지 */}
          {!data.isEnd && <span className={cx('badge')}>추가 응시 필요</span>}
        </div>

        {/* 응시내역 상세 */}
        <div className={cx('itemDesc')}>
          <div className={cx('titleArea')}>
            <div className={cx('titleInner')}>
              <div className={cx('date')}>{data.lastModifiedDateTime}</div>
              <em className={cx('title')}>{title}</em>
            </div>
            <div className={cx('optionArea')}>
              <a className={cx('btnOption')} role="button" onClick={clickMenuBtn}>
                <Icon name="moreHorizonLight" width={32} height={32} fill={Colors.C_COOL_GRAY_90} />
              </a>
              {isVisible('MENU') && (
                <div className={cx('menuArea')}>
                  <a className={cx('btnMenu')} role="button" onClick={onClickRemoveButton}>
                    이 리스트에서 제거
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className={cx('progressArea')}>
            <div className={cx('rateArea')}>
              <span className={cx('rate')}>{data.percentageText}</span>
              {data.isEnd ? (
                <Link href={V2Route.getAccaResultSnPage(data.sn)} legacyBehavior>
                  <a className={cx('link')} target="_blank" role="button">
                    결과표 보기
                    <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
                  </a>
                </Link>
              ) : (
                <a className={cx('link')} target="_blank" role="button" onClick={clickContinueBtn}>
                  이어하기
                  <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
                </a>
              )}
            </div>

            <div className={cx('progress')}>
              {/* [D] 비율에 맞게 width 값 수정 필요 */}
              <div className={cx('progressBar')} style={{ width: data.percentage }} />
            </div>
          </div>
        </div>
      </div>

      <ContinueApplyModal visible={isVisible('CONTINUE')} onClose={clickContinueBtn} onApply={handleApplyTest} />
    </>
  );
};

export default ResultListItem;
